export const validations = {
  mixed: {
    default: "فرمت {path} صحیح نمی‌باشد",
    required: "{path} الزامی می‌باشد",
    defined: "{path} باید تعریف شده باشد",
    notNull: "{path} باید وارد شود",
    oneOf: "{path} باید یکی از مقادیر {values} باشد",
    notOneOf: "{path} نباید یکی از مقادیر {values} باشد",
    notType: "فرمت {path} باید {type} باشد",
    // custom
    fileType: "فرمت {path} باید {type} باشد",
    fileSize: "حجم {path} باید حداکثر {size} مگابایت باشد"
  },
  string: {
    length: "{path} باید {length} کاراکتر باشد",
    min: "{path} باید حداقل {min} کاراکتر باشد",
    max: "{path} باید حداکثر {max} کاراکتر باشد",
    matches: "فرمت {path} صحیح نمی‌باشد",
    email: "{path} باید یک ایمیل معتبر باشد",
    url: "{path} باید یک آدرس معتبر باشد",
    uuid: "{path} باید یک آیدی معتبر باشد",
    trim: "{path} نباید شامل فاصله‌ها باشد",
    lowercase: "{path} باید حروف کوچک باشد",
    uppercase: "{path} باید حروف بزرگ باشد",
    // custom
    persian: "{path} باید فارسی باشد",
    english: "{path} باید انگلیسی باشد",
    arabic: "{path} باید عربی باشد",
    alphabet: "{path} صرفا میتواند شامل حروف الفبا باشد",
    password: "{path} باید شامل حروف بزرگ و کوچک و اعداد باشد",
    mobile: "فرمت {path} باید صحیح باشد",
    passportExpireDate: "گذرنامه مسافر باید حداقل ۶ ماه اعتبار داشته باشد.",
    nationalCode: "کدملی مسافر را به صورت صحیح وارد کنید"
  },
  number: {
    min: "{path} باید حداقل {min} رقم باشد",
    max: "{path} باید حداکثر {max} رقم باشد",
    lessThan: "{path} باید کمتر از {less} رقم باشد",
    moreThan: "{path} باید بیشتر از {more} رقم باشد",
    positive: "{path} باید بزرگتر از صفر باشد",
    negative: "{path} باید کوچکتر از صفر باشد",
    integer: "{path} باید عدد صحیح باشد"
  },
  date: {
    min: "{path} باید حداقل {min} باشد",
    max: "{path} باید حداکثر {max} باشد"
  },
  boolean: {
    isValue: "{path} باید {value} باشد"
  },
  object: {
    noUnknown: "{path} شامل فیلدهای نامشخص است"
  },
  array: {
    min: "{path} باید حداقل {min} تعداد باشد",
    max: "{path} باید حداکثر {max} تعداد باشد",
    length: "{path} باید {length} تعداد باشد"
  }
};
